import LogEnhancer from "./LogEnhancer";
/**
 *
 * @ngdoc method
 * @name app.util.logger:LogEnhancer#constructor
 * @methodOf app.util.logger:LogEnhancer
 * @param {object} $provide The log console.
 * @returns {object} promise.
 * @private
 */

var LogDecorator = function ($provide) {
    $provide.decorator("$log", [
        "$delegate",
        function ($delegate) {
            // NOTE: the LogEnhancer module returns a FUNCTION that we named `enhanceLoggerFn`
            //       All the details of how the `enhancement` works is encapsulated in LogEnhancer!
            LogEnhancer($delegate);

            return $delegate;
        }
    ]);
};

LogDecorator.$inject = ["$provide"];
export default LogDecorator;
